import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import startUpActions from "@redux/startup/actions";
import loanFormActions from "@redux/loanForm/actions";
import { BreadCrumb } from "@components/breadCrumb";
import { StartFormWrap } from "./StartStep/startFormWrap";
import { LivingSituationFormWrap } from "./LivingSituationStep/livingSituationFormWrap";
import BankStatementFormStep from "./BankStatementStep/bankStatementFormWrap";
import { STEPS } from "../../../constants/commonConstants";
import { PUBLIC_ROUTE } from "../../../route.constants";
import { RenderFormStep } from "./Render/renderFormStep";
import { PersonalLoanRouteController } from "../routing/personalLoanRouteController";
import { PageWrapper } from "@containers/PageWrapper";
import {
  bankStatementSchema,
  startSchema,
  livingSituationSchema,
} from "../schema";
import NotAllowedToProceedModal from "../components/modals/notAllowedToProceedModal";
import { FormContextProvider } from "../context/formContext";
import { StickySubmit } from "../components/stickySubmit";
import LivelihoodStep from "./LivelihoodStep";
import { livelihoodSchema } from "../schema/livelihoodSchema";
import { emptyFunction } from "@utils/helpers/emptyFunction";
import useGtmPageEvent from "@hooks/useGtmPageEvent";

export function PersonalLoan({ ...props }) {
  const { step } = useSelector((state) => state.loanForm);
  const dispatch = useDispatch();

  const stepRoutes = [
    {
      path: "",
      exact: true,
      component: StartFormWrap,
      meta: {
        validationSchema: startSchema,
      },
    },
    {
      path: PUBLIC_ROUTE.LIVING_SITUATION,
      exact: false,
      component: LivingSituationFormWrap,
      meta: {
        validationSchema: livingSituationSchema,
      },
    },
    {
      path: PUBLIC_ROUTE.LIVELIHOOD_INCOME,
      exact: false,
      component: LivelihoodStep,
      meta: {
        validationSchema: livelihoodSchema,
      },
    },
    {
      path: PUBLIC_ROUTE.BANK_STATEMENT_PAGE,
      exact: false,
      component: BankStatementFormStep,
      meta: {
        validationSchema: bankStatementSchema,
      },
    },
  ];
  
  useGtmPageEvent();

  useEffect(() => {
    dispatch(startUpActions.getLoanReasonsRequest());
    dispatch(startUpActions.fillForm());
  }, [dispatch]);

  const onStepChange = (item) => {
    dispatch(loanFormActions.setStep(item.step));
  };
  const [submitForm, setSubmitForm] = useState(() => emptyFunction);

  return (
    <FormContextProvider>
      <PageWrapper
        renderHeaderBottom={() => (
          <BreadCrumb
            steps={STEPS}
            activeStep={step}
            changeStep={onStepChange}
          />
        )}
      >
        <main>
          <PersonalLoanRouteController />
          <NotAllowedToProceedModal />
          {step < 5 &&
            <RenderFormStep
              route={stepRoutes[step - 1]}
              setSubmitForm={setSubmitForm}
            />
          }
          <StickySubmit submitForm={submitForm} />
        </main>
      </PageWrapper>
    </FormContextProvider>
  );
}

export default PersonalLoan;
